import { render } from "./Membership.vue?vue&type=template&id=e2054dcc"
import script from "./Membership.vue?vue&type=script&lang=js"
export * from "./Membership.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__